import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../auth/context";
import api from "../../services/api";
import serverHost from "../../services/serverHost";
import { formatDateTime } from "../../helpers/helpers";
import Mp3Recorder from "../../components/Mp3Recorder";

import {
  AppBar,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  TextField,
  Toolbar,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import SendIcon from "@mui/icons-material/Send";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import DeleteIcon from "@mui/icons-material/Delete";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomizedSnackbars from "../../components/alert/Alert";

const altura = window.innerHeight;
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  chatSection: {
    width: "100%",
    height: "80vh",
  },
  headBG: {
    backgroundColor: "#e0e0e0",
  },
  borderRight500: {
    borderRight: "1px solid #e0e0e0",
  },
  messageArea: {
    // marginTop: 70,
    // marginBottom: 90,
    width: window.innerWidth - "10%",
    // height: "100px",
    overflowY: "auto",
    backgroundColor: "#e0e0e0",
  },
});

let audioAux = "";
let text = "";
let tipo = "";

export default function Acompanhamento(props) {
  const [alerta, setAlerta] = useState(false);
  const history = useHistory();
  const usuario = useContext(AuthContext);
  const [listaRegistros, setListaRegistros] = useState([]);
  const [msg, setMsg] = useState("");
  const [legendaSelecionada, setLegendaSelecionada] = useState(false);
  const [audio, setAudio] = useState(undefined);
  const [audioURL, setAudioURL] = useState("");
  const [tempoAudio, setTempoAudio] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [idAudio, setIdAudio] = useState(null);

  const dadosUnidade = props.location.state.dados
    ? props.location.state.dados
    : props.location.state.dadosUnidade;

  const dadosRegistros = props.location.state.dadosUnidade
    ? props.location.state.dadosUnidade
    : "";
  useEffect(() => {
    carregarRegistros();
  }, []);

  const carregarRegistros = () => {
    const unidadeId = dadosUnidade.unidadeId
      ? dadosUnidade.unidadeId
      : dadosRegistros.unidadeId;

    const data = {
      unidadeId: unidadeId,
      profissionalId: usuario.usuario.profissionalId,
      pronunciaId: dadosRegistros.pronunciaId,
    };
    if (dadosRegistros.pronunciaId) {
      setLegendaSelecionada(true);
    }

    api
      .get("acompanhamento/carregar", data)
      .then((res) => {
        setListaRegistros(res);
      })
      .catch((e) => {
        console.log(e);

        const status = e.status;

        if (status === 400) {
          text =
            "Não foi possível obter as unidades. Verifique sua conexão e tente novamente.";
          tipo = "error";
          alertMsg();
        }
      });
  };

  const novoRegistro = (valor) => {
    const unidadeId = dadosUnidade.unidadeId
      ? dadosUnidade.unidadeId
      : dadosRegistros.unidadeId;

    const data = new FormData();

    if (audio) {
      data.append("arquivo", audio);
      data.append("tempoAudio", tempoAudio);
    }

    data.append("unidadeId", unidadeId);
    data.append("profissionalId", usuario.usuario.profissionalId);
    data.append("pronunciaId", "");
    data.append("texto", msg);

    api
      .put("acompanhamento/inserir", data)
      .then((res) => {
        setMsg("");
        setAudio(undefined);
        carregarRegistros();
      })
      .catch((e) => {
        text =
          "Não foi possível enviar o registro. Verifique sua conexão e tente novamente.";
        tipo = "error";
        alertMsg();
      });
  };

  const playAudio = (valor) => {
    console.log("valor", valor);
    setIdAudio(valor.id);
    // audioAux = new Audio(`${serverHost()}/${valor.audio}`);
    // audioAux.play();
    if (audioAux) {
      audioAux.pause(); // Para o áudio anterior se estiver tocando
      setIsPlaying(false);
    }

    audioAux = new Audio(`${serverHost()}/${valor.audio}`);

    audioAux.addEventListener("ended", () => {
      setIsPlaying(false);
    });

    audioAux.addEventListener("playing", () => {
      setIsPlaying(true);
    });

    audioAux.addEventListener("pause", () => {
      setIsPlaying(false);
    });

    audioAux.play();
  };

  const stopAudio = () => {
    setIdAudio(null);

    // audioAux.pause();
    if (audioAux) {
      audioAux.pause();
      setIsPlaying(false);
    }
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <>
      <AppBar position="fixed">
        <Toolbar style={{ background: "#E51D3D", color: "white" }}>
          <ArrowBackIcon
            onClick={() =>
              history.push({
                pathname: "unidade",
                state: { dadosUnidade: dadosUnidade },
              })
            }
            style={{
              marginRight: 20,
              cursor: "pointer",
            }}
          />
          <h2 style={{ fontFamily: "Gilroy-ExtraBold" }}>Acompanhamento</h2>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <div
        style={{
          color: "white",
          textAlign: "center",
          background: "#a3a3a3",
          fontFamily: "Gilroy-ExtraBold",
        }}
      >
        <h2>
          Unidade: {dadosUnidade.unidadeNumero} - {dadosUnidade.unidadeTitulo}
        </h2>
        <h4>
          Disponível até {formatDateTime(dadosUnidade.disponivelAte, "D/M/Y")}
        </h4>
      </div>
      {/* <br /> */}
      <Grid
        style={{
          height: altura - "200",
          margin: 20,
          backgroundColor: "#e0e0e0 ",
          overflowY: "auto",
          borderRadius: 15,
        }}
        item
        xs={9}
      >
        {listaRegistros.map((item) => (
          <>
            {!item.usuarioNome && (
              <ListItem style={{ justifyContent: "end" }} key="1">
                <Grid
                  style={{
                    background: "#E51D3D",
                    color: "white",
                    width: "50%",
                    borderRadius: 5,
                  }}
                  container
                >
                  <Grid item xs={12}>
                    <ListItemText
                      style={{ marginLeft: 10, fontFamily: "Gilroy-ExtraBold" }}
                      align="left"
                      secondary={
                        <p
                          style={{
                            fontFamily: "Gilroy-ExtraBold",
                            color: "white",
                          }}
                        >
                          {item.profissionalNome}
                        </p>
                      }
                    ></ListItemText>
                  </Grid>
                  <Grid item xs={12}>
                    <>
                      {!item.audio ? (
                        <ListItemText
                          style={{ marginLeft: 10 }}
                          align="left"
                          primary={
                            <span
                              style={{
                                fontFamily: "Gilroy-ExtraBold",
                                color: "white",
                              }}
                            >
                              {item.texto}
                            </span>
                          }
                        ></ListItemText>
                      ) : (
                        <ListItemText
                          style={{
                            background: "white",
                            marginLeft: 10,
                            marginRight: 10,
                          }}
                          align="center"
                        >
                          <span
                            style={{
                              fontFamily: "Gilroy-ExtraBold",
                              color: "#a3a3a3",
                            }}
                          >
                            Áudio - {item.tempoAudio}s
                          </span>
                          <IconButton>
                            {idAudio === item.id && isPlaying ? (
                              <StopIcon
                                onClick={() => {
                                  stopAudio();
                                }}
                              />
                            ) : (
                              <PlayArrowIcon
                                onClick={() => {
                                  playAudio(item);
                                }}
                              />
                            )}
                          </IconButton>
                        </ListItemText>
                      )}
                    </>
                  </Grid>
                  <Grid item xs={12}>
                    <ListItemText
                      style={{ marginRight: 10 }}
                      align="right"
                      secondary={formatDateTime(item.envio, "D/M/Y h:m")}
                      sx={{
                        "& .MuiListItemText-secondary": {
                          color: "white",
                        },
                      }}
                    ></ListItemText>
                  </Grid>
                </Grid>
              </ListItem>
            )}
            {item.usuarioNome && (
              <ListItem style={{ justifyContent: "" }} key="1">
                <Grid
                  style={{
                    background: "#a3a3a3",
                    color: "white",
                    width: "50%",
                    borderRadius: 5,
                  }}
                  container
                >
                  <Grid item xs={12}>
                    <ListItemText
                      style={{ marginLeft: 10 }}
                      align="left"
                      secondary={
                        <p
                          style={{
                            fontFamily: "Gilroy-ExtraBold",
                            color: "white",
                          }}
                        >
                          {item.usuarioNome}
                        </p>
                      }
                    ></ListItemText>
                  </Grid>
                  <Grid item xs={12}>
                    <>
                      {!item.audio ? (
                        <ListItemText
                          style={{ marginLeft: 10 }}
                          align="left"
                          primary={
                            <span style={{ fontFamily: "Gilroy-ExtraBold" }}>
                              {item.texto}
                            </span>
                          }
                        ></ListItemText>
                      ) : (
                        <ListItemText
                          style={{
                            background: "white",
                            marginLeft: 10,
                            marginRight: 10,
                          }}
                          align="center"
                        >
                          <span
                            style={{
                              fontFamily: "Gilroy-ExtraBold",
                              color: "#a3a3a3",
                            }}
                          >
                            Áudio - {item.tempoAudio}s
                          </span>
                          <IconButton>
                            {idAudio === item.id && isPlaying ? (
                              <StopIcon
                                onClick={() => {
                                  stopAudio();
                                }}
                              />
                            ) : (
                              <PlayArrowIcon
                                onClick={() => {
                                  playAudio(item);
                                }}
                              />
                            )}
                          </IconButton>
                        </ListItemText>
                      )}
                    </>
                  </Grid>
                  <Grid item xs={12}>
                    <ListItemText
                      style={{ marginRight: 10 }}
                      align="right"
                      secondary={formatDateTime(item.envio, "D/M/Y h:m")}
                      sx={{
                        "& .MuiListItemText-secondary": {
                          color: "white",
                        },
                      }}
                    ></ListItemText>
                  </Grid>
                </Grid>
              </ListItem>
            )}
          </>
        ))}
        {legendaSelecionada && (
          <Grid
            container
            style={{
              // paddingLeft: 15,
              backgroundColor: "#90CCFB",
              textAlign: "center",
            }}
          >
            <Grid style={{ fontSize: 16 }} xs={12}>
              <p>Pronúncia selecionada:</p>
            </Grid>

            <Grid container xs={12}>
              <Grid style={{ fontSize: 16 }} xs={12}>
                {dadosRegistros.pronunciaPalavra}
              </Grid>
              <Grid style={{ fontSize: 14 }} xs={12}>
                {dadosRegistros.pronunciaTraducao}
              </Grid>
              <Grid style={{ fontSize: 14, fontStyle: "italic" }} xs={12}>
                {dadosRegistros.pronunciaFormaFigurada}
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>

      <Toolbar />

      <AppBar position="fixed" sx={{ top: "auto", bottom: 0 }}>
        <Toolbar style={{ background: "#FFFF" }}>
          <Grid container>
            <>
              {!audio && (
                <Grid item xs={10}>
                  <TextField
                    label="Mensagem (opcional)"
                    value={msg}
                    onChange={(event) => setMsg(event.target.value)}
                    fullWidth
                    id="fullWidth"
                  />
                </Grid>
              )}
              <Grid
                alignItems="center"
                justifyContent="flex-end"
                item
                xs={!audio ? 2 : 8}
              >
                {msg ? (
                  // <ThemeProvider theme={theme2}>
                  //   <IconButton
                  //     variant="contained"
                  //     onClick={() => novoRegistro()}
                  //   >
                  //     <SendIcon
                  //       sx={{ color: "#7cc980" }}
                  //       fontSize="large"
                  //     ></SendIcon>
                  //   </IconButton>
                  // </ThemeProvider>

                  <IconButton
                    sx={{
                      background: "#7cc980",
                      color: "#FFFF",
                      marginRight: 2,
                    }}
                    onClick={() => novoRegistro()}
                  >
                    <SendIcon fontSize="large" />
                  </IconButton>
                ) : (
                  <Mp3Recorder
                    recordedAudio={audio}
                    recordedAudioURL={audioURL}
                    getAudio={(audio, audioURL, tempoAudio) => {
                      setAudio(audio);
                      setAudioURL(audioURL);
                      setTempoAudio(tempoAudio);
                    }}
                  />
                )}
              </Grid>
              <Grid
                justifyContent="flex-end"
                style={{
                  display: "flex",
                  margin: "auto",
                  textAlign: "center",
                }}
                item
                xs={4}
              >
                {audio && (
                  <>
                    <IconButton
                      onClick={() => {
                        setAudio(undefined);
                      }}
                      component="label"
                      sx={{
                        background: "#FCBE2E",
                        color: "#FFFF",
                        marginRight: 1,
                      }}
                    >
                      <DeleteIcon fontSize="large"></DeleteIcon>
                    </IconButton>
                    {/* <IconButton
                      variant="contained"
                      onClick={() => novoRegistro()}
                    >
                      <SendIcon
                        sx={{ color: "#7cc980" }}
                        fontSize="large"
                      ></SendIcon>
                    </IconButton> */}

                    <IconButton
                      sx={{
                        background: "#7cc980",
                        color: "#FFFF",
                      }}
                      onClick={() => novoRegistro()}
                    >
                      <SendIcon fontSize="large" />
                    </IconButton>
                  </>
                )}
              </Grid>
            </>
          </Grid>
        </Toolbar>
      </AppBar>
      {alerta && (
        <CustomizedSnackbars texto={text} tipo={tipo}></CustomizedSnackbars>
      )}
    </>
  );
}
